import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './config/axios'; // Configure axios to use cookies

// Silence all console output in the browser
(() => {
  try {
    const noop = () => {};
    // Set to true to allow quick toggling via env if needed
    const disable = true || process.env.REACT_APP_DISABLE_LOGGER === 'true';
    if (disable && typeof console !== 'undefined') {
      ['log', 'info', 'warn', 'debug', 'error'].forEach((m) => {
        try { console[m] = noop; } catch (_) {}
      });
    }
  } catch (_) {}
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
